import React from 'react';
import SubjectSelection from './SubjectSelection';
import './MySubjects.css';

const MySubjects = () => {
  return <SubjectSelection selectedOnly pageTitle="My Subjects" />;
};

export default MySubjects;
